import { defineRecipe } from '@chakra-ui/react'

export const inputRecipe = defineRecipe({
  base: {},
  variants: {
    variant: {
      outline: {
        border: '1px solid',
        borderColor: 'brand.blue',
        fontWeight: 400,
        background: 'white',
        borderRadius: 'sm',
        marginBottom: 0,
        '&:focus, &:focus-visible': {
          boxShadow: 'none',
          borderColor: 'brand.blue',
          outlineOffset: '-2px',
          outlineColor: 'brand.blue',
        },
        '&[data-invalid]': {
          borderColor: '#ffa200',
          boxShadow: '0 0 0 0px #ffa200',
          '&:focus, &:focus-visible': {
            boxShadow: 'none',
            borderColor: '#ffa200',
            outlineOffset: '-2px',
            outlineColor: '#ffa200',
          },
        },
      },
    },
  },
})
